export default "__VITE_PUBLIC_ASSET__ebed0e0c__"